export class TimePickerMinute {
  value: number;
  displayValue: string;

  constructor(value: number, displayValue: string) {
    this.value = value;
    this.displayValue = displayValue;
  }
}
